import React, { useState, useRef, useEffect } from "react";
import './AuthTelegram.css';
import Logo from './../Public/Image/AuthTelegram/Logo.svg';
import Google from './../Public/Image/AuthTelegram/Google.svg';
import Email from './../Public/Image/AuthTelegram/Email.svg';
import Telegram from './../Public/Image/AuthTelegram/Telegram.svg';
import TelegramRed from './../Public/Image/AuthTelegram/TelegramRed.svg';

import { API_ID, API_HASH } from './../Const'
import { BottomSheet } from 'react-spring-bottom-sheet'
import { UpdateStateTelegram, SaveSession, SetPhoneNumber, SetPhoneCodeHash } from './../app/Slice'
import LoginGoogle from './../Auth/LoginGoogle'
import { TelegramClient, Api } from 'telegram'
import { StringSession } from 'telegram/sessions'
import TelegramMini from './../Public/Image/AuthTelegram/TelegramMini.svg';
import { Box, TextField, InputAdornment } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import data from './../Auth/country2.json';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ReactCountryFlag from "react-country-flag"
// import { phone } from 'phone';
// import { Iso } from "@mui/icons-material";
import { setMiniLoading } from './../app/Home'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom';
import { SetUserTelegramPasswordStatus } from './../app/JoinState'
// import { LoginTelegram } from './../DataBase/LoginTelegram'
import { LoginTelegramDB } from "../DataBase/LoginTelegramDB";
import Dexie from 'dexie';
import { Link } from 'react-router-dom';
const AuthTelegram = () => {
    const [countryCode, setCountryCode] = useState(""); // Default country code
    const [Phone, setPhone] = useState("");
    const countryInputRef = useRef(null);
    const phoneNumberInputRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const dispatch = useDispatch()
    const MiniLoading = useSelector((state) => state.Home.MiniLoading)
    const [PHONE_NUMBER_INVALID, setPHONE_NUMBER_INVALID] = useState(false)
    const [PHONE_NUMBER_BANNED, setPHONE_NUMBER_BANNED] = useState(false)
    const [FloodWait, setFloodWait] = useState(false)
    const VerifyBotEnable = useSelector((state) => state.Game.verifyBotEnable)
    // console.log(VerifyBotEnable)
    const history = useHistory();
    const handlePhoneChange = (e) => {
        setCountryError(false)
        setPHONE_NUMBER_INVALID(false)

        setFloodWait(false)
        let input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        // console.log(input)
        input = input.trim()
        if (input === "") {
            countryInputRef.current.focus();
        }
        let detectedCode = countryCode;
        let remainingNumber = input;
        // let res = DetectCountryCode(input)


        let found = false;
        for (let code of data) {
            let cleanCode = code.Iso.replace("+", "");

            if (input.startsWith(cleanCode)) {
                if (!countryCode) {

                    setCountryISO(code.countryCode)
                    setCountryName(code.name)
                    detectedCode = cleanCode;
                    setCountryCode(detectedCode);
                    // console.log(input)
                    // console.log(cleanCode)
                    // remainingNumber = input.substring(cleanCode); 
                    remainingNumber = input.replace(cleanCode, '');

                    // console.log(remainingNumber)
                }


                found = true;
                break;
            }
        }

        if (!found) {

            detectedCode = countryCode;
            remainingNumber = input;
        }


        // console.log(remainingNumber)
        setPhone(remainingNumber);
    };

    const OpenModal = async () => {
        handleClickOpen()
    }

    const handleClickOpen = () => {
        setOpen(true);
    };
    const [open, setOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState('');
    const [CountryName, setCountryName] = useState('')
    const [CountryError, setCountryError] = useState(false)
    const [CountryISO, setCountryISO] = useState("")
    const handleClose = () => {
        setOpen(false);
    };
    const handleInputChange = e => {
        setSearchQuery(e.target.value);
        search(e.target.value);
    };

    const selectCountry = (code, name, Iso) => {
        setCountryError(false)
        setPHONE_NUMBER_INVALID(false)
        setCountryISO(Iso)
        setCountryName(name)
        code = code.replace('+', '')
        setCountryCode(code)
        handleClose()
    }
    const search = query => {
        let filteredResults = data.filter(item =>
            item.name.toLowerCase().includes(query.toLowerCase())
        );
        let filteredResultsCode = data.filter(item =>
            item.Iso.replace(" ", "").includes(query)
        );
        setSearchResults(filteredResults.length > 0 ? filteredResults : filteredResultsCode);
    };
    const CountryCodeHandlerBegin = (e) => {
        setCountryError(false)
        setPHONE_NUMBER_INVALID(false)
        // setPHONE_NUMBER_INVALID(false)
        setFloodWait(false)
        setCountryCode(e.target.value);
        let res = DetectCountryCode(e.target.value)

        if (res == true) {
            // phoneNumberInputRef.current?.focus();
        }
        // CountryCodeHandler(e.target.value)
    }

    const DetectCountryCode = (value) => {
        // console.log(value)
        if (value.length == 0) {
            setCountryISO('')
            setCountryName('')
            setCountryCode('')
        }
        if (value.startsWith('+')) {
            value = value.replace('+', '')
        }
        let UserInput = value.trim()
        let Isdetect = false
        UserInput = '+' + UserInput
        for (let index = 0; index < data.length; index++) {
            const item = data[index];
            if (UserInput.length < 5) {
                // console.log(UserInput)
                if (item.Iso.replace(/\s/g, '') == UserInput) {
                    // console.log(3)
                    setCountryISO(item.countryCode)
                    setCountryName(item.name)
                    setCountryCode(item.Iso)
                    Isdetect = true
                }
            } else {


                if (UserInput.startsWith(item.Iso)) {


                    UserInput = UserInput.replace(item.Iso, "");
                    setCountryISO(item.countryCode)
                    setCountryName(item.name)
                    setCountryCode(item.Iso)
                    setPhone(UserInput);
                    phoneNumberInputRef.current.focus();
                }
            }

        }
        return Isdetect
    }
    const stringSession = new StringSession('');
    const Client = new TelegramClient(stringSession, Number(API_ID), API_HASH, {
        connectionRetries: 3, timeout: 3
    });

    useEffect(() => {
        localStorage.removeItem("AllowSend")
        localStorage.removeItem('PassWord2Step')
        localStorage.removeItem('AllowSendCode')
        localStorage.removeItem('setCodeErrorSetLocalAllow')
        localStorage.removeItem('Code')
        dispatch(SetUserTelegramPasswordStatus(false));

    }, [])

    // const AddTelegramNumberToDB = async () => {
    async function AddTelegramNumberToDB(country, phone) {
        // let resdata = await LoginTelegramDB.Data.toArray()
        // console.log(resdata)
        // console.log(phone)
        let Status = await Dexie.exists('LoginTelegramDB').then(async function (exists) {
            if (!exists) {
                // console.log(exists)
                var newdb = new Dexie('LoginTelegramDB');
                newdb.version(1).stores({
                    Data: '++id, Session,PhoneNumber,User,ProfilePhoto,BotSession,CountryName,CountryNameIso'
                });
                LoginTelegramDB.open();
                const id = await newdb.Data.add({
                    PhoneNumber: country + phone, CountryName: country, Session: '', User: '', ProfilePhoto: '', BotSession: ''
                });
            } else {
                // console.log(exists)
                try {
                    LoginTelegramDB.open();
                    let resdata = await LoginTelegramDB.Data.toArray()
                    // console.log(resdata)
                    if (resdata[0].id) {
                        let res = LoginTelegramDB.Data.where({ id: Number(resdata[0].id) }).modify({ PhoneNumber: phone, CountryName: country })
                    }

                } catch (error) {
                    console.log(error)
                }

            }
        });

    }
    const ContinueFunction = async () => {
        phoneNumberInputRef.current.blur();


        // await db.Data.where({ id: Number(Account.id) }).modify({ AutoJoin: false })
        let country = countryCode
        let phone = Phone
        country = country.trim()
        phone = phone.trim()
        //   (async function () {
        // console.log(phone)
        // console.log(country)
        AddTelegramNumberToDB(country, phone)
        // })();
        // console.log(phoneNumberInputRef.current)
        if (CountryName == '') {
            setCountryError(true)

            const focusInput = () => {
                if (phoneNumberInputRef.current) {
                    phoneNumberInputRef.current.focus();
                } else {
                    setTimeout(focusInput, 100); // تلاش دوباره پس از 100 میلی‌ثانیه
                }
            };
            focusInput();

        } else {
            dispatch(setMiniLoading(true))

            let res
            try {


                res = await Client.connect();

                // console.log(res)
            } catch (error) {

                // setConnectionError(true)
                // setSnackbaropen(true)
                dispatch(setMiniLoading(false))
            }

            if (res === false) {
                // setConnectionError(true)
                dispatch(setMiniLoading(false))
                // setSnackbaropen(true)

            } else if (res == true || res == undefined) {
                try {

                    const sendcode = await Client.invoke(
                        new Api.auth.SendCode({
                            phoneNumber: country + phone,

                            apiId: API_ID,
                            apiHash: API_HASH,
                            settings: new Api.CodeSettings({
                                allowFlashcall: false,
                            }),
                        })
                    );

                    // console.log(sendcode)


                    localStorage.setItem('SessionLogin', JSON.stringify(Client.session.save()))
                    localStorage.setItem('PhoneNumberLogin', country + phone)
                    country = country.replace('+', '');
                    localStorage.setItem('CountryCodeLogin', country)
                    dispatch(SaveSession(Client.session.save()))


                    dispatch(UpdateStateTelegram('CodeSent'))
                    dispatch(SetPhoneNumber(country + phone))
                    dispatch(SetPhoneCodeHash(sendcode.phoneCodeHash))
                    dispatch(setMiniLoading(false))
                    history.push(`/VerifyTelegramCodeLogin`);
                    // VerifyTelegramCodeLogin
                } catch (error) {
                    dispatch(setMiniLoading(false))

                    if (error.errorMessage === 'PHONE_NUMBER_INVALID') {
                        setPHONE_NUMBER_INVALID(true)
                    } else if (error.errorMessage === 'FLOOD' || error.errorMessage == "PHONE_PASSWORD_FLOOD") {

                        // let Second = error.seconds
                        setFloodWait(true)
                        // setFloodWaitTime(Second)
                        // var mind = Second % (60 * 60);
                        // var minutes = Math.floor(mind / 60);

                        // AddTelegramSession(error.seconds,CountryCode + PhoneNumber)
                    } else if (error.errorMessage == "PHONE_NUMBER_BANNED") {
                        setPHONE_NUMBER_BANNED(true)

                    }
                    // setErrorLogin(true)
                }
            }

            // }
        }
    }

    function onDismiss() {
        setTimeout(() => {

            setFloodWait(false)
        }, 300);


    }

    return (
        <div className='LoginWithTelgram'>
            <div className="LoginWithTelegramBg"></div>
            <div className='LoginWithTelegramLogo'>
                <img src={Logo} className='LoginWithTelegramLogoImg' alt="Logo" />
            </div>
            <div className='LoginWithTelegramHeader'>
                For
                <span className='LoginWithTelegramTelegramMiniContainer'>
                    <img src={TelegramMini} className='LoginWithTelegramTelegramMini' alt="Telegram" />
                </span>
                Telegram login, please enter your country code and phone number
            </div>
            <div className="LoginWithTelgramInputs">

                <div className='LoginTelegramBodyText'
                    style={{ zIndex: "2", borderRadius: "10px" }}
                    onClick={(e) => OpenModal(e.target.value)}>
                    <div className='LoginTelegramBodyTextCountry'>
                        {
                            CountryISO ?
                                <>
                                    <ReactCountryFlag

                                        countryCode={CountryISO}
                                        className="FlagPhoneNumber"
                                        style={{ marginRight: "4px" }}
                                        svg
                                        title={CountryISO}
                                    />

                                </>
                                : null
                        }
                        {CountryName ? CountryName : "Country"}
                    </div>
                    <div className=''>
                        <KeyboardArrowRightIcon className='LoginTelegramBodyTextIcon' />
                    </div>
                </div>
                {CountryError ?
                    <TextField

                        error
                        id="outlined-error"
                        variant="outlined"
                        onChange={handlePhoneChange}

                        type="tel"
                        value={Phone}
                        className={isFocused ? "Mui-focused LoginWithTelgramPhoneInput" : "LoginWithTelgramPhoneInput"}

                        fullWidth
                        InputLabelProps={{
                            shrink: isFocused || countryCode.length > 0 || Phone.length > 0, // کنترل لیبل برای بالا ماندن
                        }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        helperText={`Phone number is empty`}
                        min={0}
                        label={
                            <span style={{ display: "flex", alignItems: "center", gap: "5px", "height": "32px" }}>
                                {
                                    isFocused || Phone.length > 0 || countryCode.length > 0 ?
                                        null
                                        : <img src={TelegramRed} />
                                }
                                Telegram number
                            </span>
                        }
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" className={"InputAdornment1"} >
                                    <input
                                        ref={countryInputRef}
                                        // isFocused || Phone.length > 0 ?
                                        className={isFocused || Phone.length > 0 ? "Mui-focused LoginWithTelgramPhoneNumberDivInput" : "LoginWithTelgramPhoneNumberDivInputBorderless"}
                                        value={countryCode}
                                        onChange={(e) => { CountryCodeHandlerBegin(e) }}
                                        onFocus={() => setIsFocused(true)}
                                        onBlur={() => setIsFocused(false)}
                                    />

                                </InputAdornment>
                            )
                        }}

                        sx={{

                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                background: "#fff",
                                height: "64px",
                                fontSize: "16px",

                                transition: "border 0.3s ease-in-out",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#D32F2F"
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    border: "2px solid #D32F2F",

                                },

                            },
                            "& .MuiInputLabel-root": {


                                ...(isFocused && {
                                    outline: "none",
                                    color: "#D32F2F",


                                }),
                            },
                            "& .MuiInputLabel-root": {

                                backgroundColor: "#fff", // پس‌زمینه سفید تا متن روی بردر نیفته
                                padding: "0 5px",

                                ...(isFocused && {
                                    outline: "none",
                                    color: "#D32F2F",


                                }),
                            },
                        }}
                    />
                    :
                    PHONE_NUMBER_INVALID ?
                        <TextField
                            error
                            id="outlined-error"
                            variant="outlined"
                            onChange={handlePhoneChange}
                            helperText={`Phone number is incorrect`}
                            type="tel"
                            value={Phone}
                            className={isFocused ? "Mui-focused LoginWithTelgramPhoneInput" : "LoginWithTelgramPhoneInput"}

                            fullWidth
                            InputLabelProps={{
                                shrink: isFocused || countryCode.length > 0 || Phone.length > 0, // کنترل لیبل برای بالا ماندن
                            }}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}

                            min={0}
                            label={
                                <span style={{ display: "flex", alignItems: "center", gap: "5px", "height": "32px" }}>
                                    {
                                        isFocused || Phone.length > 0 || countryCode.length > 0 ?
                                            null
                                            : <img src={TelegramRed} />
                                    }
                                    Telegram number
                                </span>
                            }
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" className={"InputAdornment1"} >
                                        <input
                                            ref={countryInputRef}
                                            // isFocused || Phone.length > 0 ?
                                            className={isFocused || Phone.length > 0 ? "Mui-focused LoginWithTelgramPhoneNumberDivInput" : "LoginWithTelgramPhoneNumberDivInputBorderless"}
                                            value={countryCode}
                                            onChange={(e) => { CountryCodeHandlerBegin(e) }}
                                            onFocus={() => setIsFocused(true)}
                                            onBlur={() => setIsFocused(false)}
                                        />

                                    </InputAdornment>
                                )
                            }}

                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "10px",
                                    background: "#fff",
                                    height: "64px",
                                    fontSize: "16px",

                                    transition: "border 0.3s ease-in-out",
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#D32F2F"
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        border: "1px solid #D32F2F",

                                    },

                                },
                                "& .MuiInputLabel-root": {


                                    ...(isFocused && {
                                        outline: "none",
                                        color: "#D32F2F",


                                    }),
                                },
                                "& .MuiInputLabel-root": {

                                    backgroundColor: "#fff", // پس‌زمینه سفید تا متن روی بردر نیفته
                                    padding: "0 5px",

                                    ...(isFocused && {
                                        outline: "none",
                                        color: "#D32F2F",


                                    }),
                                },
                            }}
                        />
                        :
                        <TextField
                            type="tel"
                            inputRef={phoneNumberInputRef}
                            value={Phone}
                            onChange={handlePhoneChange}

                            label={
                                <span style={{ display: "flex", alignItems: "center", gap: "5px", "height": "32px" }}>
                                    {
                                        isFocused || Phone.length > 0 || countryCode.length > 0 ?
                                            null
                                            : <img src={Telegram} />
                                    }
                                    Telegram number
                                </span>
                            }
                            className={isFocused ? "Mui-focused LoginWithTelgramPhoneInput" : "LoginWithTelgramPhoneInput"}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: isFocused || countryCode.length > 0 || Phone.length > 0, // کنترل لیبل برای بالا ماندن
                            }}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" className={"InputAdornment1"} >
                                        <input
                                            ref={countryInputRef}
                                            type="tel"
                                            // isFocused || Phone.length > 0 ?
                                            className={isFocused || Phone.length > 0 ? "Mui-focused LoginWithTelgramPhoneNumberDivInput" : "LoginWithTelgramPhoneNumberDivInputBorderless"}
                                            value={countryCode}
                                            onChange={(e) => { CountryCodeHandlerBegin(e) }}
                                            onFocus={() => setIsFocused(true)}
                                            onBlur={() => setIsFocused(false)}

                                        />

                                    </InputAdornment>
                                )
                            }}

                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "10px",
                                    background: "#fff",
                                    height: "64px",
                                    fontSize: "16px",

                                    transition: "border 0.3s ease-in-out",
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        // borderColor: "#1976d2"
                                        borderColor: '#BDBDBD',
                                        ...(isFocused && {
                                            border: "2px solid #1976d2",


                                        }),
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        border: "2px solid #1976d2",
                                        // border: "2px solid #BDBDBD",

                                    },


                                },
                                "& .MuiInputLabel-root": {


                                    ...(isFocused && {
                                        outline: "none",
                                        color: "#1976d2",


                                    }),
                                },
                                "& .MuiInputLabel-root": {

                                    backgroundColor: "#fff", // پس‌زمینه سفید تا متن روی بردر نیفته
                                    padding: "0 5px",

                                    ...(isFocused && {
                                        outline: "none",
                                        color: "#1976d2",


                                    }),
                                },
                            }}

                        />
                }


                <div className="LoginWithTelegramContinueContainer">
                    <button className="LoginWithTelegramContinue" onClick={() => MiniLoading ? null : ContinueFunction()}>
                        {MiniLoading ?
                            <div className="loadminijoin" style={{ width: "8px", height: "8px" }}>
                                {/* <img src={Vector} style={{'display':'flex'}}/> */}
                            </div>
                            :
                            'Continue'

                        }
                    </button>
                </div>
            </div>
            <div className="LoginNewDivider">
                <div className="divider">
                    <span>Or continue with</span>
                </div>

            </div>
            <div className="NewLoginEmailGmail">
                {
                    window.Telegram ?
                        window.Telegram.WebApp.platform != 'unknown' ?
                            null
                            :   <LoginGoogle />
                            
                        :
                        <LoginGoogle />
                }


                <Link to="/Register" className="LoginNewWithEmail">
                    <img className="EmailIconNew" src={Email} />  Email
                </Link>


            </div>
            <div className="NewLoginTOS">
                <div className="NewLoginTOSText1">
                    Sign in to app means you agree to
                    <a className="NewLoginTOSText2" href="https://nox.membersgram.com/tos/">&nbsp; Terms of Service</a>
                    &nbsp;   and &nbsp;
                    <a className="NewLoginTOSText2" href="https://nox.membersgram.com/privacy/"> Privacy Policy</a>
                </div>
                {/* <div className="NewLoginTOSInner">
                  
                </div> */}
            </div>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    <div className='SearchDiv'>
                        <input type='text' value={searchQuery}
                            className='SearchInput'
                            placeholder='Search country'
                            autoFocus
                            onChange={(e) => { handleInputChange(e) }} />
                        <CloseIcon onClick={handleClose} className='CloseModalIcon' />
                    </div>

                </DialogTitle>
                <DialogContent dividers>
                    <div className='ListOfCountry'>
                        {
                            searchResults.length > 0 && searchResults != '' ?
                                searchResults.map((item, i) =>
                                    <div className='ListCountryItem' key={i + 1} onClick={() => selectCountry(item.Iso, item.name, item.countryCode)}>
                                        <div key={i} className='ListCountryItemLast'>
                                            {item.name}({item.Iso})
                                        </div>


                                    </div>
                                )
                                :
                                data.map((item, i) =>
                                    <div className='ListCountryItem' key={i} onClick={() => selectCountry(item.Iso, item.name, item.countryCode)}>
                                        <div key={i} className='ListCountryItemLast'>
                                            {item.name}({item.Iso})
                                        </div>


                                    </div>
                                )
                        }
                    </div>



                </DialogContent>

            </Dialog>
            <BottomSheet onDismiss={onDismiss} open={FloodWait}>
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className='RegisterBeforeBottomSheetHeaderText'>Number limitation</div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBody'>
                        <span className='PhoneNumberInBottomSheet'>+{countryCode + Phone}</span> is restricted, and you cannot log in with it. Please wait for a while or use another number
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        {/* <button className='BottomSheetCancelButton' >Cancel</button>  */}
                        <button style={{ 'width': '100%' }} className='BottomSheetLoginButton' onClick={() => setFloodWait(false)} >Got it</button>
                    </div>
                </div>
            </BottomSheet>
            <BottomSheet onDismiss={onDismiss}
                open={PHONE_NUMBER_BANNED}
            // open={true}
            >
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className='RegisterBeforeBottomSheetHeaderText'>Account banned</div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBodyBanned'>
                        <span className='PhoneNumberInBottomSheet'>
                            {/* <img src={Bannedicon} className='BannedImage'/> */}
                        </span>Number has been banned by Telegram, Please enter a different number
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        {/* <button className='BottomSheetCancelButton' >Cancel</button>  */}
                        <button style={{ 'width': '100%' }} className='BottomSheetLoginButton' onClick={() => setPHONE_NUMBER_BANNED(false)} >Got it</button>
                    </div>
                </div>
            </BottomSheet>
        </div >
    )
}

export default AuthTelegram;
